import { Briefcase, Building2, Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface EntitySelectorProps {
  value: "opportunity" | "account" | "person";
  onChange: (value: "opportunity" | "account" | "person") => void;
  disabled?: boolean;
}

const ENTITY_OPTIONS = [
  {
    value: "opportunity" as const,
    label: "Opportunities",
    icon: Briefcase,
    available: true,
  },
  {
    value: "account" as const,
    label: "Accounts",
    icon: Building2,
    available: true,
  },
  {
    value: "person" as const,
    label: "People",
    icon: Users,
    available: false,
  },
];

export function EntitySelector({
  value,
  onChange,
  disabled,
}: EntitySelectorProps) {
  const selectedOption = ENTITY_OPTIONS.find((opt) => opt.value === value);

  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-[200px] bg-white dark:bg-[hsl(195_30%_12%)] rounded-lg corner-smooth-lg font-medium">
        <SelectValue placeholder="Select entity type...">
          {selectedOption && (
            <div className="flex items-center gap-2">
              <selectedOption.icon className="h-4 w-4" />
              <span>{selectedOption.label}</span>
            </div>
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {ENTITY_OPTIONS.map((option) => {
          const OptionIcon = option.icon;
          return (
            <SelectItem
              key={option.value}
              value={option.value}
              disabled={!option.available}
            >
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center space-x-2">
                  <OptionIcon className="h-4 w-4" />
                  <span>{option.label}</span>
                </div>
                {!option.available && (
                  <Badge variant="secondary" className="ml-2 text-xs">
                    Coming Soon
                  </Badge>
                )}
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
